import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { handleActions } from 'redux-actions';
import { addActivityQueue, clearActivityQueue } from '../actions/global';
export default handleActions({
    [`${addActivityQueue}`]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            roomsQueue: [
                ...state.roomsQueue,
                action.payload.room_id
            ]
        }),
    [`${clearActivityQueue}`]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            roomsQueue: []
        })
}, {
    roomsQueue: []
});

//# sourceMappingURL=global.js.map